const INITIAL_STATE = {
  orderTypeList: [],
  orderTypeListIndustry: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_ORDERS_TYPE': {
      return { ...state, orderTypeList: action.ordersTypes };
    }
    case 'SET_ORDERS_TYPE_INDUSTRY': {
      return { ...state, orderTypeListIndustry: [...action.orderTypeListIndustry] };
    }
    default:
      return state;
  }
};
